import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getTradePlacesBloomberg,
  saveBatchTradePlacesBloomberg,
} from '../../api/tradePlacesBloomberg';
import type { TradePlaceBloomberg } from '../../types/TradePlaceBloomberg';
import { t } from '../../i18n/t';

const columnDefs: ColDef<TradePlaceBloomberg>[] = [
  {
    field: 'tradePlaceIdBloomberg',
    headerName: t('tradePlacesBloomberg.columns.tradePlaceIdBloomberg'),
    width: 200,
    cellDataType: 'text',
    // String natural PK: editable on Add only, read-only after save.
    editable: (params: EditableCallbackParams<TradePlaceBloomberg>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'tradePlaceId',
    headerName: t('tradePlacesBloomberg.columns.tradePlaceId'),
    width: 140,
    cellDataType: 'number',
    editable: true,
  },
  {
    field: 'isLeadingExchange',
    headerName: t('tradePlacesBloomberg.columns.isLeadingExchange'),
    width: 150,
    cellDataType: 'boolean',
    editable: true,
  },
  {
    field: 'countryId',
    headerName: t('tradePlacesBloomberg.columns.countryId'),
    width: 140,
    cellDataType: 'number',
    editable: true,
  },
];

const newRowDefaults = (): Partial<TradePlaceBloomberg> => ({
  tradePlaceIdBloomberg: '',
  tradePlaceId: 0,
  isLeadingExchange: false,
  countryId: null,
});

export function TradePlacesBloombergPage() {
  return (
    <LopCrudPage<TradePlaceBloomberg>
      resourceCode="tradePlacesBloomberg"
      titleKey="tradePlacesBloomberg.pageTitle"
      idField="tradePlaceIdBloomberg"
      getRows={getTradePlacesBloomberg}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchTradePlacesBloomberg(added, modified, deletedIds as string[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
